import { Component, EventEmitter, Input, OnChanges, OnInit, AfterViewInit, Output, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule, FormBuilder, FormArray, } from '@angular/forms';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { IsochroneService } from '../../../../../src/app/isochrone-module/isochrone.service';
import { AddAttributesComponent } from '../add-attributes/add-attributes.component';
import { MatDialog } from '@angular/material/dialog';
import { CartographyService } from '../../../../../src/app/cartography-module/cartography.service';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { object } from 'underscore';
import { AppAnalysisService } from 'src/app/app-analysis-module/app-analysis.service';
@Component({
  selector: 'lib-common-poly-nav',
  standalone:true,
  imports:[CommonModule,FormsModule,ReactiveFormsModule,MatInputModule,MatSidenavModule,MatButtonModule,FlexLayoutModule],
  templateUrl: './common-poly-nav.component.html',
  styleUrls: ['./common-poly-nav.component.css']
})
export class CommonPolyNavComponent implements OnInit, OnChanges {
  @ViewChild('showInfo') showInfo!: MatSidenav;
  @Input() layerValues: any
  @Input() layerId: any

  //Ritivesh - Input for single draw
  @Input() single: any
  @Output() deleteGeometryEmit = new EventEmitter<any>()
  @Input() moduleName: any
  @Output() layerValuesData = new EventEmitter<any>()
  @Output() deletePointEmit = new EventEmitter<any>()
  @Output() editGeometry = new EventEmitter<any>()
  @Output() saveGeometry = new EventEmitter<any>()
  popUpData: any = []
  formData: any
  mapLayers: any
  geometry: any
  // formData
  canHideValue: any = false
  canRunSliderFn:any = false;
  attributeData: any = []
  attributes:any = []
  pop: any;
  validationForm:any = [];
  index: any;
  counter: any;


  getF(data: any) {
    // console.warn(this.newForm.value)
    if (this.moduleName == 'add points') {
      this.iconName = data.iconStyle.iconName
    }
    for (let o of data.form_data) {
      this.data.push(this.fb.group({
        Name: [o.Name],
        Value: [o.Value],
        // Type: [o.type.attribute_type]
        type:{
          "attribute_type": o.type.attribute_type
        }
        
      }))
    }
    this.data.patchValue(data.form_data)
    // console.warn(this.data)
  }


  show = false
  empForm!: FormGroup;
  newForm!: FormGroup
  constructor(private fb: FormBuilder,
    private MatDialog: MatDialog,
    private AppAnalysisService: AppAnalysisService,
    private _isochroneService: IsochroneService,
    private cartographyService: CartographyService) {
    this.empForm = this.fb.group({
      employees: this.fb.array([]),
    })
  }

  get getQuestions() {
    return this.empForm.controls['questionArray'] as FormArray;
  }
  fieldData: any;


  ngOnInit() {

    // this.AppAnalysisService.getAllAtributesListOfLayer(this.layerId).subscribe((data: any) => {
    //   let attributes: any = []
    //   attributes = data.data;
    //   this.fieldData = []
    //   attributes.forEach((element: any, i: any) => {
    //     this.fieldData.push({ Name: attributes[i].column_name, type: attributes[i].domain_name, required: attributes[i].required })
    //     this.addDataCommon(this.fieldData);
    //   });
    //   console.warn(this.fieldData)
    // });

    this._isochroneService.commonPolyNavGetModuleName.subscribe(moduleName => {
      this.moduleName = moduleName;
    })

    this._isochroneService.layerData.subscribe(data => {
      this.layerValues = data;
    });

    // this._isochroneService.addAttribute.subscribe(data => {
    //   this.addDataCommon(data)
    //   // this.getFormData()

    // })

    this._isochroneService.layerdataDelete.subscribe(data => {
      this.remove(data)
    })
    this._isochroneService.commonPolyNavCloseInfo.subscribe(data => {
      this.closeShowInfo();
    })
    this._isochroneService.resetCommonPolynav.subscribe(data => {
      // this.newForm.reset();
      this.closeShowInfo();
      // this.newForm.value.data.forEach((element, i) => {
      //   this.newForm.value.data[i].Value = ""
      //   if (i > 0)
      //     this.newForm.value.data.splice(i, 1)
      // });

      // data.clear();
    })
    let counter = 0
    this._isochroneService.commonPolyNavShowSlider.subscribe(data => {
      this.canRunSliderFn = true;
      if (!this.layerId) {
        if (data.geometry) {
          counter++
          // if(data.geometry.type=="POLYGON" || data.geometry.type=="POLYLINE"){
          if (counter <= 1 && data.form_data.length != 1) {
            data.form_data = [data.form_data[0]]
          } else {
            this.showSlider(data);
          }
          // }
        } else if (counter <= 1 && data.form_data.length != 2) {
          let data1 = data.form_data[1]
          data.form_data = [data.form_data[0]]
          data.form_data.push(data1)
          this.showSlider(data);
        }
        else {
          this.showSlider(data);
        }
      } else {
        this.showSlider(data);
      }
    })
    this.newForm = this.fb.group({
      data: this.fb.array([
        // this.putData()
      ])
    })
    // console.warn(this.newForm.value.data)

  }

  ngAfterViewInit(): void {
    if (!this.layerId) {
      this.setDataForFormTypeValidations()
    }
  }
  // this.validationForm = [
  //   { attribute_name: 'default_icon', attribute_type: 'string' },
  //   { attribute_name: 'name', attribute_type: 'string' }
  // ]

  getMapLayers(layers: any) {
    this.mapLayers = layers;
    this.setDataForFormTypeValidations();
  }

  imageData=[]
  onFileSelect(event: any, index: number) {
    const file = event.target.files[0];
    
    if (file) {
        // You can do additional processing here, such as validating file type or size
        this.imageData.push({name:this.data.controls[index].value.Name,file:file});
        this.data.controls[index].get('Value')?.setValue(file);
    }
}

  setDataTypeInValidation(type: string) {
    if (type == 'Varchar') {
      return 'Varchar'
    }
    else {
      return type
    }
  }

  setDataForFormTypeValidationsWithLayer(layer: { attributes: any[]; }) {
    layer.attributes.forEach((element: { column_name: string; data_type: any; }) => {
      if (element.column_name !== 'gid') {
        let newObj = { attribute_name: element.column_name, attribute_type: this.setDataTypeInValidation(element.data_type) };
        this.validationForm.push(newObj);
      }
    });
  }

 
  get dataControls(): AbstractControl[] {
    const dataControl = this.newForm.get('data');
    return dataControl instanceof FormArray
      ? dataControl.controls
      : [];
  }
  

  setDataForFormTypeValidations() {
    if (this.layerId) {
      let index = this.mapLayers.findIndex((a: { layerid: any; }) => a.layerid == this.layerId);
      let layer_details = this.mapLayers[index];
      this.setDataForFormTypeValidationsWithLayer(layer_details)
    }
    else {
      if (this.moduleName == 'add points') {
        this.validationForm = [
          { attribute_name: 'default_icon', attribute_type: 'Varchar' },
          { attribute_name: 'name', attribute_type: 'Varchar' }
        ]
      }
      else if (this.moduleName !== 'add points') {
        this.validationForm = [
          { attribute_name: 'name', attribute_type: 'Varchar' }
        ]
      }
    }
  }


  putData() {
    return this.fb.group({
      Name: [''],
      Value: [],
      type: [{"attribute_type":""}]
    })
  }

  get data() {
    return this.newForm.get('data') as FormArray
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if(changes.layerValues.currentValue){
    //   this.formData = this.layerValues.form_data
    //   this.getF()
    // }
    // console.warn(this.formData)
  }

  employees(): FormArray {
    return this.empForm.get("employees") as FormArray
  }
  newData(): FormGroup {
    return this.fb.group({
      Name: '',
      Value: '',
      // Type: ''
      type:{
        "attribute_type": ""
      }
      

    })
  }
  addData() {
    this.data.push(this.putData())
    // console.log("Adding a data");
    this.show = true
    // this.employees().push(this.newData());
  }
  onSubmit() {
    // console.log(this.empForm.value.employees)
  }

  removeData(Index: number) {
    this.employees().removeAt(Index);
  }


  openShowInfo() {
    this.showInfo.open()
  }

  closeShowInfo() {

    // this.getFormData()
    this.showInfo.close()
  }
  // updateAttribut(data){
  //   console.log(data)
  // }
  remove(i: number) {
    this.data.removeAt(i)
    this.index = i
    this.getF(this.data)
    this.getFormData()
  }

  checkVariableType(str: any) {
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  }

  checkVarType(str: any) {
    let isNumber: any = this.checkVariableType(str)
    if (isNumber) {
      return 'number'
    }
    else {
      return 'Varchar'
    }
  }

  getFormValidationStatus() {
    let counter = 0
    // {attribute_name: 'default_icon', attribute_type: 'string'},
    // console.log(this.validationForm)
    // console.log(this.newForm.value.data)
    this.validationForm.forEach((value: { attribute_name: any; }, index: any) => {

      this.newForm.value.data.forEach((element: { Name: any; }, index1: string | number) => {
        if (element.Name == value.attribute_name) {
          if (this.newForm.value.data[index1].Value != "") {
            if (this.validationForm[index].attribute_type != "Varchar") {
              if (this.checkVarType(this.newForm.value.data[index1].Value) !== this.validationForm[index].attribute_type) {
                counter++;
              }
            }
          }
        }
      });
    })

    return counter
  }
  
  getFormData(save_data=false) {
    // this.counter = this.getFormValidationStatus()
    // if (this.counter > 0) {
    //   console.warn(this.counter)
    //   this._isochroneService.openSnackBar("Please input correct attribute value", "snackbar-error", "fail");
    //   return
    // }
    // console.warn(this.newForm.value.data)
    // this.layerValues.form_data = this.newForm.value.data
    // console.log(this.layerValues)
    this.newForm.value.data.forEach((element: any, index: any) => {
      this.popUpData.forEach((element: any, i: string | number) => {
        if (this.newForm.value.data[index].Name == this.popUpData[i].attribute_name) {
          this.newForm.value.data[index].type = this.popUpData[i]
        }
      });
      if (this.newForm.value.data[index].Name == "name") {
        this.newForm.value.data[index].type = { attribute_type: "Varchar" }
      } else if (this.newForm.value.data[index].Name == "default_icon") {
        this.newForm.value.data[index].type = { attribute_type: "Varchar" }
      }
      try {
        if (this.layerId) {
          this.layerValues.form_data.forEach((element: any, ind: any) => {
            if (this.newForm.value.data[index].Name == this.layerValues.form_data[ind].Name) {
              this.newForm.value.data[index].type = this.layerValues.form_data[ind].type
            }
          });
        }
      } catch {

      }

    });

    // });
    if(this.newForm.value.data.length !=0){ 
        this.layerValuesData.emit({ id: this.layerUniqueId, data: this.newForm.value.data,"save_data":save_data })
        this._isochroneService.commonPolyNavLayerValueDataFn({ id: this.layerUniqueId, data: this.newForm.value.data,"save_data":save_data})
        this._isochroneService.shareImageData(this.imageData);
    }
    // this._isochroneService.commonPolyNavLayerValueDataFn({ id: this.layerUniqueId, data: this.newForm.value.data })


    this.showInfo.close()
  }

  checkRequired(name:any){
    let ArrIndex = this.attributeData.findIndex((a: any)=>a.Name == name)
    if(ArrIndex!=-1){
      if(this.attributeData[ArrIndex].required){
        return true
      }else{
        return false
      }
    }else{
      return false

    }
    
  }

  layerUniqueId: any
  iconName: any
  // showSlider(data:any) {
  //   if (this.canRunSliderFn) {
  //     if (this.attributeData.length != data.form_data.length) {
  //       let newArray:any = [].concat(data.form_data, this.newForm.value.data)
  //       data.form_data = this.getUniqueCLegends(newArray)
  //       // this.attributeData.forEach((element,index) => {
  //       //   if(data.form_data.length >2){
  //       //   data.form_data.forEach((element,i) => {
  //       //     if(this.newForm.value.data[i].Name){
  //       //     if(data.form_data[i].Name != this.newForm.value.data[i].Name ){
  //       //       data.form_data.push(this.newForm.value.data[index])
  //       //     }
  //       //   }
  //       // });
  //       // }else{
  //       //     data.form_data.push(this.newForm.value.data[index+1])
  //       //   }

  //       // });
  //       if (data.form_data.length > 1) {
  //         data.form_data.forEach((element: any, i: any) => {
  //           if (data.form_data[i] == undefined) {
  //             data.form_data.splice(i, 1)
  //           }
  //         });
  //         // data.form_data = this.getUniqueCLegends(data.form_data)
  //       }
  //       // data.form_data.push(this.attributeData[1])
  //     }
  //     //     if(this.attributeData.length >= 1){
  //     //     this.attributeData.forEach((element,index) => {
  //     //       if(this.attributeData[index].Value != data.form_data[index].Value){
  //     //         data.form_data[index].Value = ""
  //     //       }

  //     //     this.geometry = data;
  //     //     this.attributeData = data.form_data
  //     //     this.newForm.reset()
  //     //     this.data.controls = []
  //     //     this.getF(data)
  //     //     this.layerUniqueId = data.properties.id
  //     //   })
  //     // }else{
  //     data.form_data.forEach((element: any, i: any) => {
  //       if (data.form_data[i].Value == "NULL") {
  //         data.form_data[i].Value = ""
  //       }
  //     });
  //     this.geometry = data;
  //     this.attributeData = data.form_data
  //     this.newForm.reset()
  //     this.data.controls = []
  //     this.getF(data)
  //     this.layerUniqueId = data.properties.id
  //     // }

  //     // data.form_data.forEach((element,i) => {
  //     //   if(data.form_data[i].Name != "default_icon"){
  //     //   data.form_data[i].Value = ""
  //     //   }
  //     // });

  //     this.data.patchValue(data.form_data)
  //     this.showInfo.open()
  //   }
  //   this.canRunSliderFn = false;
  // }

  showSlider(data: any) {
    if (this.canRunSliderFn) {
      if (data && data.form_data) { // Check if data and data.form_data are defined
        if (this.attributeData.length != data.form_data.length) {
          let newArray: any = [].concat(data.form_data, this.newForm.value.data);
          data.form_data = this.getUniqueCLegends(newArray);
  
          if (data.form_data.length > 1) {
            data.form_data.forEach((element: any, i: any) => {
              if (data.form_data[i] === undefined) {
                data.form_data.splice(i, 1);
              }
            });
          }
        }
  
        data.form_data.forEach((element: any, i: any) => {
          if (data.form_data[i].Value === "NULL") {
            data.form_data[i].Value = "";
          }
        });
  
        this.geometry = data;
        this.attributeData = data.form_data;
        this.newForm.reset();
        this.data.controls = [];
        this.getF(data);
        this.layerUniqueId = data.properties.id;
  
        this.data.patchValue(data.form_data);
        this.showInfo.open();
      } else {
        console.warn("Data or data.form_data is undefined");
      }
    }
    this.canRunSliderFn = false;
  }
  
  getUniqueCLegends(data: any[]) {

    // console.warn(data)
    try {
      var newObjArr = data.reduce(function (previous: { filter: (arg0: (item: any) => boolean) => { (): any; new(): any; length: number; }; push: (arg0: any) => void; }, current: { Name: any; }) {
        var alredyExists = previous.filter(function (item: { Name: any; }) {
          return item.Name === current.Name
        }).length > 0
        if (!alredyExists) {
          previous.push(current)
        }
        return previous
      }, [])
    } catch { }

    return newObjArr
  }

  deletePoint() {

    if (this.moduleName == 'polygon' || this.moduleName == 'polyline') {
      this.deleteGeometryEmit.emit(this.geometry.properties.id)
      this._isochroneService.commonPolyNavDeleteGeometryFN(this.geometry.properties.id);
    }
    else if (this.moduleName == 'add points') {
      this.deletePointEmit.emit(this.layerUniqueId);
      // this._isochroneService.commonPolyNavDeleteGeometryFN(this.layerUniqueId);
      this.showInfo.close();
    }
  }
  addNewFieldDialog() {
    const dialog = this.MatDialog.open(AddAttributesComponent, {
      width: "400px",

      //  data: {attributes}
    })

    dialog.afterClosed().subscribe(result => {
      // console.log(result)
      this.addDataCommon(result)
    })


  }

  addDataCommon(result: { attribute_name: any; attribute_type: any; }) {

    if (result) {
      this.pop = []
      this.popUpData.push(result) 
      this.addDataInValidationForm(result);
      const insertForm = this.fb.group({
        "Name": result.attribute_name,
        "Value": "",
        // "Type": result.attribute_type
        "type": {
          "attribute_type": result.attribute_type
        }
      })
      this.data.push(insertForm)

      this.attributeData = this.data.value
     

      if (this.layerId) {

        let attributes_data = [{ "attribute_name": result.attribute_name, "default_value": "", "attribute_type": result.attribute_type }]
        this.cartographyService.insertLayerAttribute(this.layerId, attributes_data).subscribe(data => {
          // console.log(data);
          if (data) {
            // this.updateLayerAttributes.emit(true)
          }
        });
      }

      // this.getFormData()


    }
  }
  // {attribute_name: 'default_icon', attribute_type: 'string'},



  addDataInValidationForm(res: { attribute_name: any; attribute_type: string; }) {
    let resObj = { attribute_name: res.attribute_name, attribute_type: res.attribute_type }
    if (res.attribute_type == 'Varchar' || res.attribute_type == 'varchar') {
      resObj.attribute_type = 'Varchar';
    }
    else {
      resObj.attribute_type = res.attribute_type;
    }
    this.validationForm.push(resObj);
  }


  CheckQuestionType(index: string | number) {
    return this.data.value[index]
  }

  FileAndImageData:any=[]
  @ViewChild('fileInput') fileInput!: ElementRef;

  onImageFileSelect(event:Event, formIndex: any) {
    if (event) {

      // this.data.at(formIndex).setValue(null);
      // let itemFormGroup = this.data.at(formIndex) as FormGroup
      // itemFormGroup.patchValue({Value:null})
      const fileInput:any = event.target as HTMLInputElement;

      let objData = this.data.value[formIndex]
      let ArrIndex = this.FileAndImageData.findIndex((a: { id: any; })=>a.id == formIndex)
      if(ArrIndex == -1){
        this.FileAndImageData.push({
          "id":formIndex,
          "attribute_name":objData.Name,
          "attribute_type":objData.Type,
          "value":fileInput.files[0]
        })
      }else{
        this.FileAndImageData[ArrIndex].value =fileInput.files[0] 
      }
      // console.log(this.FileAndImageData)
    }
  }


  @Output() EditGeomEvent :EventEmitter<any> = new EventEmitter<any>()
  // EditGeom(){
  //   this.EditGeomEvent.emit()
  //   this.closeShowInfo()
  // }
  //Ritivesh Function
  editGeom(){
    this.closeShowInfo()
    if(this.moduleName == 'add points'){
      //point edit geom event
      this.EditGeomEvent.emit()

    }else{
      this.editGeometry.emit(true)

    }



  }

  saveData(){
    this.getFormData()
    this.saveGeometry.emit(this.FileAndImageData)
    

  }

}
